import { render, staticRenderFns } from "./DadhboardWrapper.vue?vue&type=template&id=55ea03a2&scoped=true&"
import script from "./DadhboardWrapper.vue?vue&type=script&lang=ts&"
export * from "./DadhboardWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ea03a2",
  null
  
)

export default component.exports